export default "__VITE_ASSET__BKpjKTzH__"